// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-annotator-container {
  font-size: 0.8rem !important;
  text-transform: none !important;

  .jsoneditor-popover{
    word-break: break-all
  }

  .toolbar {
    padding-left: 18px;
    position: absolute;
    min-height: 10px;
    padding-right: 15px;
    padding-top: 3px;
  }

  .file-menu-icon {
    width: 40px;
    height: 40px;
  }

  .MuiPaper-elevation {
    margin-top: 0px;
    padding-top: 0px;
    height: 100% !important;
    padding-right: 10px;
    /* background: azure; */
  }

  .search-input-container {
    width: 100%;
    height: 35px !important;
    border: 1px solid darkgrey;
    padding-right: 0px;
    padding: 2px 4px;
    display: flex;
    align-items: center;
  }

  .search-button {
    width: 25px;
    height: 25px;
    padding: 0px;
  }

  .close-menu-icon {
    width: 40px;
    height: 40px;
  }

  .menu-logo {
    margin-right: 6px;
    padding-left: 10px;
    margin-right: 16%;
  }

  .close-btn-container {
    width: 10%;
    height: 40px;
    margin-right: -10%;
    background: #dfe6e9;
    border-radius: 10px 0px 0px 10px;
  }

  .file-list-element {
    height: 30px;
    border-bottom: 1px solid #dfe6e9;
  }

  .file-name {
    height: 30px;
  }

  .collection-files {
    border-top: 1px solid rgb(223, 230, 233);
    padding-top: 0px;
    margin-top: 8px;
  }

  .selected-file {
    background-color: #1976d2;
    color: white;
  }

  .file-name-text {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 160px;
    height: 1.5em;
    white-space: nowrap;

    .MuiListItemText-primary {
      font-size: 0.8rem;
    }
  }

  .tabs-header-section {
    display: flex;
    align-items: center;
    gap: 10px;
    overflow: auto !important;
    overflow-y: inherit;
    width: 100%;
  }

  .editor-tabls-container {
    flex: 2 1;
    /* Takes 2 parts */
    margin-bottom: 0px;
    justify-items: center;
    height: 32px;

    .MuiTabs-scroller {

      /* overflow: auto !important;
      overflow-y: inherit; */
      .MuiTabs-flexContainer {
        height: 32px;
        width: 100%;
        display: flex;
        margin-left: 0%;
      }
    }
  }

  .section-schema {
    flex: 1 1;
    /* Takes 1 part */
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: flex-end;
  }

  .section-selector {
    border: 1px solid #ccc;
    background: #6c757d;
    border-radius: 4px;
    font-weight: 500;
    padding: 4px;
    height: 37px;
    color: white;
    min-width: 100px;
    margin-left: 1%;
  }

  .pdf-viwer-container-loader {
    position: relative;
    top: 50%;
    left: 45%;
    margin-left: -30px;
    margin-top: -35px;
  }

  .schema-compare-error {
    text-align: end;
    margin-top: -8px;
    color: red;
  }

  .menu-option {
    padding: 5px;
    width: 150px;
  }


  .editor-drager {
    cursor: "ew-resize";
    width: "8px";
    background: "#6200ea";
    display: "flex";
    align-items: "center";
    justify-content: "center";
    background-color: #b2bec3;
  }

  .left-editor-header {
    display: flex;
    margin-left: 5%;
    justify-content: center;
    margin-top: -15px;
  }

  .file-search-input {
    margin-top: -4px;
    width: 90%;
    margin-right: 3%;
    margin-left: max(30px, 3%);

    input {
      height: 12px;
      font-size: 0.8rem;
    }
  }

  .submit-button {
    margin-top: -4px;
    margin-right: 3%;
  }

  .pdf-viwer-container {
    /* margin-top:2%; */
    border: 1px solid #ddd;
    padding: 5px 10px 10px 10px;
    height: 94%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .pdf-viewer {
    height: 100%;
  }

  .text-view-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .text-view {
    height: 20px;
    min-width: 100px;
  }

  .text-file-viewer {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  .zoom-viewer {
    display: flex;
    align-items: center;
    /* margin-top: -16px; */
  }

  .text-header-container {
    display: flex;
    height: 20px;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
  }

  .tab-items {
    padding: 0px 0px 0px 0px;
    width: 20%;
  }

  .section-selector:focus {
    border-color: #6200ea;
    box-shadow: 0 0 5px rgba(98, 0, 234, 0.5);
  }

  .section-selector .MuiSelect-icon {
    color: #6200ea;
  }

  .json-form-editor {
    padding: 0px 10px 10px 10px;
  }

  .close-button {
    background-color: transparent;
    color: #4e545a;
    border: none;
    padding: 0px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 700;
    z-index: 10;
    font-size: 27px;
    line-height: 0px;
    margin-left: 3%;
    margin-top: -4%;
  }


  .close-button:hover {
    /* background-color: #cc0000; */
  }

  .close-btn-div {
    width: 100%;
    display: flex;
    justify-content: end;
    margin-top: 2%;
  }

  .json-form-tab-container {
    margin-top: -45px;
  }

  .json-form-edit-box {
    border: 1px solid #ddd;
    padding: 2%;
    height: 91.5%;
    overflow: auto;
  }

  .jsoneditor-frame {
    display: none
  }

  .expand-button {
    background: none;
    border: none;
  }

  .update-buttons {
    margin-right: 4%;
    position: absolute;
    margin-top: 38%;
    width: -webkit-fill-available;
    text-align: -webkit-right;
  }

  .update-buttons-bottom {
    margin-top: 4%;
    margin-bottom: 3%;
    width: -webkit-fill-available;
    text-align: -webkit-center;
  }

  .update-textsec-bottom {
    margin-top: 1%;
    margin-bottom: -1%;
    width: -webkit-fill-available;
    text-align: -webkit-center;
  }

  .edit-switch {
    margin-left: 1%;
    margin-right: 1%;
  }

  .disabled-save-button {
    background: transparent;
    border: none;
    border-radius: 5px;
    color: white;
    font-size: 0.8rem;
    margin-left: 1%;
    cursor: not-allowed;
    padding: 0px;
  }

  .save-button {
    background: transparent;
    border: none;
    border-radius: 5px;
    color: white;
    font-size: 0.8rem;
    margin-left: 1%;
    cursor: pointer;
    padding: 0px;
  }

  .empty-data-message {
    width: 100%;
    text-align: center;
    color: red;
    margin-top: 2%;
  }

  .save-button:hover {
    border-color: none;
    box-shadow: 0px;
  }

  .save-button-json{
    background: transparent;
    border: none;
    border-radius: 5px;
    color: white;
    font-size: 0.8rem;
    margin-left: 1%;
    cursor: pointer;
    padding: 0px;
    margin-right: 3%;
    margin-top: 1%;
    z-index: 10
  }
  .save-button:hover {
    border-color: none;
    box-shadow: 0px;
  }

  .save-icon {
    width: 28px;

  }

  .update-button {
    border: none;
    background: #6c757d;
    font-weight: 800;
    padding: 10px;
    width: 80px;
    border-radius: 5px;
    margin-right: 3%;
    color: white;
    font-size: 0.8rem;
  }

  .update-button:hover {
    border-color: #6c757d;
    box-shadow: 0 0 5px #6c757d;
  }

  /* src/components/PDFViewer.css */
  .viewer-container {
    width: 100%;
    max-width: 1000px;
    margin: 20px auto;
    overflow-y: auto;
    height: 90vh;
    padding: 20px;
    border: 1px solid #ccc;
  }

  .page {
    margin-bottom: 10px;
    text-align: center;
  }

  .canvas-container {
    width: 100%;
    border: 1px solid #000;
  }

  .controls {
    text-align: center;
    margin-top: 10px;
  }

  .controller-buttons {
    padding: 10px;
    margin: 5px;
    cursor: pointer;
  }

  .td-delete-button {
    display: block;
    padding: 5px 10px;
    background: none;
    border: none;
    color: #ff6b6b;
    border-radius: 3px;
    border-radius: 50%;
  }

  .td-delete-button:hover {
    box-shadow: 0 0 5px #ffd6d6;
    background-color: #ffd6d6;
    color: #fc5858;
  }

  .td-controller {
    text-align: -webkit-center;
    width: 60px !important;
  }

  .td-submit-button {
    border: none;
    background: #1976d2;
    font-weight: 800;
    padding: 5px 9px 3px 9px;
    border-radius: 45%;
    color: white;
    font-size: 1rem;
  }

  .td-submit-button:hover {
    border-color: #1976d2;
    box-shadow: 0 0 5px #1976d2;
  }

  .td-indexing {
    max-width: 50px;
  }

  .dynamic-form-render {
    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: auto;
      /* Columns adjust based on content */
      table-layout: fixed;
      /* Fixes the table width */
      overflow-x: auto;
      /* Allow horizontal scrolling if needed */
    }

    td {
      border: 1px solid #ddd;
      padding: 8px;
      white-space: nowrap;
      /* Prevent text from wrapping */
      width: auto;
      /* Let the column width be determined by content */
      /* Hide overflow text */
      text-overflow: ellipsis;
      /* Add ellipsis (...) if text overflows */
      overflow: hidden;
    }

    input[type="text"] {
      width: 100%;
      /* Ensure input fields take up full width of the cell */
      padding: 4px;
      border: 1px solid #ccc;
      border-radius: 4px;
      box-sizing: border-box;
      /* Include padding in the element's total width */
    }
  }

}

.schema-editor-modal-container {
  .schema-count-input {
    width: 90%;

    .MuiOutlinedInput-root {
      width: 100%;
      height: 40px;
    }

    input {
      height: 12px;
      font-size: 0.8rem;
    }
  }

  .schema-count-button {
    padding: 10px 20px;
    height: 40px;
  }

  .schema-clsoe-button {
    height: 40px;
    padding: 0px;
    position: absolute;
    left: 92.9%;
    top: 0px;
    background: transparent;
    box-shadow: none;
    color: black;
    padding-left: 30px;
    font-size: 25px;
  }

  .schema-clsoe-button:hover {
    box-shadow: none;
    background-color: transparent;

  }

  .json-editor-element {
    height: 100%;
    flex-grow: 1;
    max-height: 100%;
    overflow: auto;
    border: 1px solid #ccc;
    padding: 10px;
    margin-top: 20px
  }

  .json-edit-container {
    display: flex;
    height: 80vh;
    flex-direction: column;
  }

  .json-edit-body {
    display: flex;
    height: 100%;
    flex-direction: row;
  }

  .json-edit-left-panel {
    flex: 0.7 1;
    padding-right: 20px;
    overflow-y: auto;
  }

  .json-edit-title {
    margin-bottom: 0px;
    font-weight: bold;
    text-align: center;
    color: #333;
  }

  .json-edit-subtitle {
    font-weight: bold;
  }

  .json-edit-input-group {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .schema-count-input {
    margin-right: 10px;
  }

  .json-edit-items-title {
    font-weight: bold;
    margin-bottom: 5px;
    margin-top: 10px;
    display: flex;
  }

  .json-edit-item {
    padding: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    cursor: pointer;
    background-color: white;
  }

  .json-edit-item.selected {
    background-color: #e0e0e0;
  }

  .json-edit-right-panel {
    flex: 2 1;
    display: flex;
    flex-direction: column;
  }

  .json-editor-element {
    flex-grow: 1;
    height: 100%;
  }

  .json-edit-buttons {
    display: flex;
    justify-content: center;
  }

  .json-edit-button {
    margin: 5px;
    padding: 6px 20px;
    width: 32%;
  }

  .save-button {
    background-color: #00b894;
  }

  .validate-button {
    background-color: darkslategrey;
  }

  .json-edit-error {
    text-align: center;
    margin-top: 15px;
  }

  .ace_editor,
  .ace_editor * {
    font-family: "Monaco", "Menlo", "Ubuntu Mono", "Droid Sans Mono", "Consolas", monospace !important;
    font-size: 0.9rem !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
  }

  .error-message-contaienr {
    position: absolute;
    top: -3%;
    width: 100%;
    margin-left: -20px;
    text-align: center;
    margin-top: -15px;
  }

  .alert-message {
    padding: 9px 41px;
    border-radius: 5px;
  }

  .success-message {
    background-color: #d1fae5;
    color: #047857;
  }

  .error-message {
    background-color: #fee2e2;
    color: #b91c1c;
  }

  .info-message {
    background-color: #bfdbfe;
    color: #1d4ed8;
  }

  .schema-downloader {
    width: 21px;
    padding: 5px 0px 5px 2px;
    font-size: 13px;
    background: transparent;
    color: black;
    box-shadow: none;
    cursor: pointer;
  }

}`, "",{"version":3,"sources":["webpack://./src/assets/styles/fileannotator.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,+BAA+B;;EAE/B;IACE;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;;IAEnB;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,SAAO;IACP,kBAAkB;IAElB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;;IAEZ;;MAEE;4BACsB;MACtB;QACE,YAAY;QACZ,WAAW;QACX,aAAa;QACb,eAAe;MACjB;IACF;EACF;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;;EAGA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,0BAA0B;;IAE1B;MACE,YAAY;MACZ,iBAAiB;IACnB;EACF;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,yCAAyC;EAC3C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;;EAGA;IACE,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,cAAc;EAChB;;EAEA;IACE;EACF;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd;EACF;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;;EAEb;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;MACE,WAAW;MACX,yBAAyB;MACzB,kBAAkB;MAClB,oCAAoC;MACpC,mBAAmB;MACnB,0BAA0B;MAC1B,gBAAgB;MAChB,yCAAyC;IAC3C;;IAEA;MACE,sBAAsB;MACtB,YAAY;MACZ,mBAAmB;MACnB,+BAA+B;MAC/B,WAAW;MACX,kDAAkD;MAElD,uBAAuB;MACvB,uBAAuB;MACvB,yCAAyC;MACzC,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,uDAAuD;MACvD,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,sBAAsB;MACtB,iDAAiD;IACnD;EACF;;AAEF;;AAEA;EACE;IACE,UAAU;;IAEV;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,YAAY;MACZ,iBAAiB;IACnB;EACF;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;;EAE/B;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb;EACF;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,kGAAkG;IAClG,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;AAEF","sourcesContent":[".file-annotator-container {\n  font-size: 0.8rem !important;\n  text-transform: none !important;\n\n  .jsoneditor-popover{\n    word-break: break-all\n  }\n\n  .toolbar {\n    padding-left: 18px;\n    position: absolute;\n    min-height: 10px;\n    padding-right: 15px;\n    padding-top: 3px;\n  }\n\n  .file-menu-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .MuiPaper-elevation {\n    margin-top: 0px;\n    padding-top: 0px;\n    height: 100% !important;\n    padding-right: 10px;\n    /* background: azure; */\n  }\n\n  .search-input-container {\n    width: 100%;\n    height: 35px !important;\n    border: 1px solid darkgrey;\n    padding-right: 0px;\n    padding: 2px 4px;\n    display: flex;\n    align-items: center;\n  }\n\n  .search-button {\n    width: 25px;\n    height: 25px;\n    padding: 0px;\n  }\n\n  .close-menu-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .menu-logo {\n    margin-right: 6px;\n    padding-left: 10px;\n    margin-right: 16%;\n  }\n\n  .close-btn-container {\n    width: 10%;\n    height: 40px;\n    margin-right: -10%;\n    background: #dfe6e9;\n    border-radius: 10px 0px 0px 10px;\n  }\n\n  .file-list-element {\n    height: 30px;\n    border-bottom: 1px solid #dfe6e9;\n  }\n\n  .file-name {\n    height: 30px;\n  }\n\n  .collection-files {\n    border-top: 1px solid rgb(223, 230, 233);\n    padding-top: 0px;\n    margin-top: 8px;\n  }\n\n  .selected-file {\n    background-color: #1976d2;\n    color: white;\n  }\n\n  .file-name-text {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 160px;\n    height: 1.5em;\n    white-space: nowrap;\n\n    .MuiListItemText-primary {\n      font-size: 0.8rem;\n    }\n  }\n\n  .tabs-header-section {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    overflow: auto !important;\n    overflow-y: inherit;\n    width: 100%;\n  }\n\n  .editor-tabls-container {\n    flex: 2;\n    /* Takes 2 parts */\n    height: 32px;\n    margin-bottom: 0px;\n    justify-items: center;\n    height: 32px;\n\n    .MuiTabs-scroller {\n\n      /* overflow: auto !important;\n      overflow-y: inherit; */\n      .MuiTabs-flexContainer {\n        height: 32px;\n        width: 100%;\n        display: flex;\n        margin-left: 0%;\n      }\n    }\n  }\n\n  .section-schema {\n    flex: 1;\n    /* Takes 1 part */\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  .section-selector {\n    border: 1px solid #ccc;\n    background: #6c757d;\n    border-radius: 4px;\n    font-weight: 500;\n    padding: 4px;\n    height: 37px;\n    color: white;\n    min-width: 100px;\n    margin-left: 1%;\n  }\n\n  .pdf-viwer-container-loader {\n    position: relative;\n    top: 50%;\n    left: 45%;\n    margin-left: -30px;\n    margin-top: -35px;\n  }\n\n  .schema-compare-error {\n    text-align: end;\n    margin-top: -8px;\n    color: red;\n  }\n\n  .menu-option {\n    padding: 5px;\n    width: 150px;\n  }\n\n\n  .editor-drager {\n    cursor: \"ew-resize\";\n    width: \"8px\";\n    background: \"#6200ea\";\n    display: \"flex\";\n    align-items: \"center\";\n    justify-content: \"center\";\n    background-color: #b2bec3;\n  }\n\n  .left-editor-header {\n    display: flex;\n    margin-left: 5%;\n    justify-content: center;\n    margin-top: -15px;\n  }\n\n  .file-search-input {\n    margin-top: -4px;\n    width: 90%;\n    margin-right: 3%;\n    margin-left: max(30px, 3%);\n\n    input {\n      height: 12px;\n      font-size: 0.8rem;\n    }\n  }\n\n  .submit-button {\n    margin-top: -4px;\n    margin-right: 3%;\n  }\n\n  .pdf-viwer-container {\n    /* margin-top:2%; */\n    border: 1px solid #ddd;\n    padding: 5px 10px 10px 10px;\n    height: 94%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .pdf-viewer {\n    height: 100%;\n  }\n\n  .text-view-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n\n  .text-view {\n    height: 20px;\n    min-width: 100px;\n  }\n\n  .text-file-viewer {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n  }\n\n  .zoom-viewer {\n    display: flex;\n    align-items: center;\n    /* margin-top: -16px; */\n  }\n\n  .text-header-container {\n    display: flex;\n    height: 20px;\n    justify-content: space-between;\n    border-bottom: 1px solid #ddd;\n  }\n\n  .tab-items {\n    padding: 0px 0px 0px 0px;\n    width: 20%;\n  }\n\n  .section-selector:focus {\n    border-color: #6200ea;\n    box-shadow: 0 0 5px rgba(98, 0, 234, 0.5);\n  }\n\n  .section-selector .MuiSelect-icon {\n    color: #6200ea;\n  }\n\n  .json-form-editor {\n    padding: 0px 10px 10px 10px;\n  }\n\n  .close-button {\n    background-color: transparent;\n    color: #4e545a;\n    border: none;\n    padding: 0px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: 700;\n    z-index: 10;\n    font-size: 27px;\n    line-height: 0px;\n    margin-left: 3%;\n    margin-top: -4%;\n  }\n\n\n  .close-button:hover {\n    /* background-color: #cc0000; */\n  }\n\n  .close-btn-div {\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    margin-top: 2%;\n  }\n\n  .json-form-tab-container {\n    margin-top: -45px;\n  }\n\n  .json-form-edit-box {\n    border: 1px solid #ddd;\n    padding: 2%;\n    height: 91.5%;\n    overflow: auto;\n  }\n\n  .jsoneditor-frame {\n    display: none\n  }\n\n  .expand-button {\n    background: none;\n    border: none;\n  }\n\n  .update-buttons {\n    margin-right: 4%;\n    position: absolute;\n    margin-top: 38%;\n    width: -webkit-fill-available;\n    text-align: -webkit-right;\n  }\n\n  .update-buttons-bottom {\n    margin-top: 4%;\n    margin-bottom: 3%;\n    width: -webkit-fill-available;\n    text-align: -webkit-center;\n  }\n\n  .update-textsec-bottom {\n    margin-top: 1%;\n    margin-bottom: -1%;\n    width: -webkit-fill-available;\n    text-align: -webkit-center;\n  }\n\n  .edit-switch {\n    margin-left: 1%;\n    margin-right: 1%;\n  }\n\n  .disabled-save-button {\n    background: transparent;\n    border: none;\n    border-radius: 5px;\n    color: white;\n    font-size: 0.8rem;\n    margin-left: 1%;\n    cursor: not-allowed;\n    padding: 0px;\n  }\n\n  .save-button {\n    background: transparent;\n    border: none;\n    border-radius: 5px;\n    color: white;\n    font-size: 0.8rem;\n    margin-left: 1%;\n    cursor: pointer;\n    padding: 0px;\n  }\n\n  .empty-data-message {\n    width: 100%;\n    text-align: center;\n    color: red;\n    margin-top: 2%;\n  }\n\n  .save-button:hover {\n    border-color: none;\n    box-shadow: 0px;\n  }\n\n  .save-button-json{\n    background: transparent;\n    border: none;\n    border-radius: 5px;\n    color: white;\n    font-size: 0.8rem;\n    margin-left: 1%;\n    cursor: pointer;\n    padding: 0px;\n    margin-right: 3%;\n    margin-top: 1%;\n    z-index: 10\n  }\n  .save-button:hover {\n    border-color: none;\n    box-shadow: 0px;\n  }\n\n  .save-icon {\n    width: 28px;\n\n  }\n\n  .update-button {\n    border: none;\n    background: #6c757d;\n    font-weight: 800;\n    padding: 10px;\n    width: 80px;\n    border-radius: 5px;\n    margin-right: 3%;\n    color: white;\n    font-size: 0.8rem;\n  }\n\n  .update-button:hover {\n    border-color: #6c757d;\n    box-shadow: 0 0 5px #6c757d;\n  }\n\n  /* src/components/PDFViewer.css */\n  .viewer-container {\n    width: 100%;\n    max-width: 1000px;\n    margin: 20px auto;\n    overflow-y: auto;\n    height: 90vh;\n    padding: 20px;\n    border: 1px solid #ccc;\n  }\n\n  .page {\n    margin-bottom: 10px;\n    text-align: center;\n  }\n\n  .canvas-container {\n    width: 100%;\n    border: 1px solid #000;\n  }\n\n  .controls {\n    text-align: center;\n    margin-top: 10px;\n  }\n\n  .controller-buttons {\n    padding: 10px;\n    margin: 5px;\n    cursor: pointer;\n  }\n\n  .td-delete-button {\n    display: block;\n    padding: 5px 10px;\n    background: none;\n    border: none;\n    color: #ff6b6b;\n    border-radius: 3px;\n    border-radius: 50%;\n  }\n\n  .td-delete-button:hover {\n    box-shadow: 0 0 5px #ffd6d6;\n    background-color: #ffd6d6;\n    color: #fc5858;\n  }\n\n  .td-controller {\n    text-align: -webkit-center;\n    width: 60px !important;\n  }\n\n  .td-submit-button {\n    border: none;\n    background: #1976d2;\n    font-weight: 800;\n    padding: 5px 9px 3px 9px;\n    border-radius: 45%;\n    color: white;\n    font-size: 1rem;\n  }\n\n  .td-submit-button:hover {\n    border-color: #1976d2;\n    box-shadow: 0 0 5px #1976d2;\n  }\n\n  .td-indexing {\n    max-width: 50px;\n  }\n\n  .dynamic-form-render {\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      table-layout: auto;\n      /* Columns adjust based on content */\n      table-layout: fixed;\n      /* Fixes the table width */\n      overflow-x: auto;\n      /* Allow horizontal scrolling if needed */\n    }\n\n    td {\n      border: 1px solid #ddd;\n      padding: 8px;\n      white-space: nowrap;\n      /* Prevent text from wrapping */\n      width: auto;\n      /* Let the column width be determined by content */\n      overflow: hidden;\n      /* Hide overflow text */\n      text-overflow: ellipsis;\n      /* Add ellipsis (...) if text overflows */\n      overflow: hidden;\n    }\n\n    input[type=\"text\"] {\n      width: 100%;\n      /* Ensure input fields take up full width of the cell */\n      padding: 4px;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      box-sizing: border-box;\n      /* Include padding in the element's total width */\n    }\n  }\n\n}\n\n.schema-editor-modal-container {\n  .schema-count-input {\n    width: 90%;\n\n    .MuiOutlinedInput-root {\n      width: 100%;\n      height: 40px;\n    }\n\n    input {\n      height: 12px;\n      font-size: 0.8rem;\n    }\n  }\n\n  .schema-count-button {\n    padding: 10px 20px;\n    height: 40px;\n  }\n\n  .schema-clsoe-button {\n    height: 40px;\n    padding: 0px;\n    position: absolute;\n    left: 92.9%;\n    top: 0px;\n    background: transparent;\n    box-shadow: none;\n    color: black;\n    padding-left: 30px;\n    font-size: 25px;\n  }\n\n  .schema-clsoe-button:hover {\n    box-shadow: none;\n    background-color: transparent;\n\n  }\n\n  .json-editor-element {\n    height: 100%;\n    flex-grow: 1;\n    max-height: 100%;\n    overflow: auto;\n    border: 1px solid #ccc;\n    padding: 10px;\n    margin-top: 20px\n  }\n\n  .json-edit-container {\n    display: flex;\n    height: 80vh;\n    flex-direction: column;\n  }\n\n  .json-edit-body {\n    display: flex;\n    height: 100%;\n    flex-direction: row;\n  }\n\n  .json-edit-left-panel {\n    flex: 0.7 1;\n    padding-right: 20px;\n    overflow-y: auto;\n  }\n\n  .json-edit-title {\n    margin-bottom: 0px;\n    font-weight: bold;\n    text-align: center;\n    color: #333;\n  }\n\n  .json-edit-subtitle {\n    font-weight: bold;\n  }\n\n  .json-edit-input-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .schema-count-input {\n    margin-right: 10px;\n  }\n\n  .json-edit-items-title {\n    font-weight: bold;\n    margin-bottom: 5px;\n    margin-top: 10px;\n    display: flex;\n  }\n\n  .json-edit-item {\n    padding: 10px;\n    border: 1px solid #ccc;\n    margin-bottom: 10px;\n    cursor: pointer;\n    background-color: white;\n  }\n\n  .json-edit-item.selected {\n    background-color: #e0e0e0;\n  }\n\n  .json-edit-right-panel {\n    flex: 2;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .json-editor-element {\n    flex-grow: 1;\n    height: 100%;\n  }\n\n  .json-edit-buttons {\n    display: flex;\n    justify-content: center;\n  }\n\n  .json-edit-button {\n    margin: 5px;\n    padding: 6px 20px;\n    width: 32%;\n  }\n\n  .save-button {\n    background-color: #00b894;\n  }\n\n  .validate-button {\n    background-color: darkslategrey;\n  }\n\n  .json-edit-error {\n    text-align: center;\n    margin-top: 15px;\n  }\n\n  .ace_editor,\n  .ace_editor * {\n    font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", \"Droid Sans Mono\", \"Consolas\", monospace !important;\n    font-size: 0.9rem !important;\n    font-weight: 400 !important;\n    letter-spacing: 0 !important;\n  }\n\n  .error-message-contaienr {\n    position: absolute;\n    top: -3%;\n    width: 100%;\n    margin-left: -20px;\n    text-align: center;\n    margin-top: -15px;\n  }\n\n  .alert-message {\n    padding: 9px 41px;\n    border-radius: 5px;\n  }\n\n  .success-message {\n    background-color: #d1fae5;\n    color: #047857;\n  }\n\n  .error-message {\n    background-color: #fee2e2;\n    color: #b91c1c;\n  }\n\n  .info-message {\n    background-color: #bfdbfe;\n    color: #1d4ed8;\n  }\n\n  .schema-downloader {\n    width: 21px;\n    padding: 5px 0px 5px 2px;\n    font-size: 13px;\n    background: transparent;\n    color: black;\n    box-shadow: none;\n    cursor: pointer;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
